import { render, staticRenderFns } from "./subject-distribute.vue?vue&type=template&id=76b11056&scoped=true"
import script from "./subject-distribute.vue?vue&type=script&lang=js"
export * from "./subject-distribute.vue?vue&type=script&lang=js"
import style0 from "./subject-distribute.vue?vue&type=style&index=0&id=76b11056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b11056",
  null
  
)

export default component.exports